/** Impressoras ativas (ausência do campo conta como ativa). */
export function filterActivePrinters(printers) {
    return (printers || []).filter((printer) => printer?.active !== false);
}

const printerNameCollator = new Intl.Collator('pt-BR', {
    sensitivity: 'base',
    numeric: true,
});

export function sortPrintersByName(printers) {
    return [...(printers || [])].sort((a, b) => (
        printerNameCollator.compare(a?.name || '', b?.name || '')
    ));
}

/** Ordem de cadastro: mais antiga primeiro (estável, não varia com métricas). */
export function sortPrintersByRegistrationOrder(printers) {
    const list = [...(printers || [])];
    if (list.length <= 1) {
        return list;
    }

    const hasCreatedAt = list.some((printer) => printer?.created_at);
    if (hasCreatedAt) {
        return list.sort((a, b) => {
            const aTime = Date.parse(a.created_at) || 0;
            const bTime = Date.parse(b.created_at) || 0;
            if (aTime !== bTime) {
                return aTime - bTime;
            }
            return printerNameCollator.compare(a?.name || '', b?.name || '');
        });
    }

    // API lista por created_at DESC; inverter = ordem de cadastro crescente.
    return list.reverse();
}

const PRINTER_TYPE_SEP = '\u001f';

export function printerTypeKey(brand, model) {
    return `${String(brand || '').trim()}${PRINTER_TYPE_SEP}${String(model || '').trim()}`;
}

export function parsePrinterTypeKey(key) {
    if (!key) {
        return { brand: '', model: '' };
    }
    const raw = String(key);
    const idx = raw.indexOf(PRINTER_TYPE_SEP);
    if (idx < 0) {
        return { brand: raw.trim(), model: '' };
    }
    return {
        brand: raw.slice(0, idx).trim(),
        model: raw.slice(idx + PRINTER_TYPE_SEP.length).trim(),
    };
}

export function formatPrinterTypeLabel(brand, model) {
    const label = [brand, model].map((part) => String(part || '').trim()).filter(Boolean).join(' ');
    return label || 'Tipo sem nome';
}

/** Tipos únicos (marca + modelo) a partir das impressoras informadas. */
export function uniquePrinterTypes(printers) {
    const map = new Map();
    (printers || []).forEach((printer) => {
        const brand = String(printer?.brand || '').trim();
        const model = String(printer?.model || '').trim();
        if (!brand) {
            return;
        }
        const key = printerTypeKey(brand, model);
        if (!map.has(key)) {
            map.set(key, {
                key,
                brand,
                model,
                label: formatPrinterTypeLabel(brand, model),
            });
        }
    });
    return [...map.values()].sort((a, b) => (
        printerNameCollator.compare(a.label, b.label)
    ));
}
